<template>
  <div id="app">
    <div v-if="show">
      <!-- {{ list.termName }} -->
      <el-select size="small" v-model="termId" @change="changeTerm" placeholder="请选择">
        <el-option
          v-for="item in termList"
          :key="item.id"
          :label="item.title"
          :value="item.id"
        >
        </el-option>
      </el-select>
       <el-button type="primary" size="small"  @click="bao"
        >保存</el-button
      >
      <div>
        <el-upload
          style="width: 300px; height: 900px; margin: 20px 0"
          class="avatar-uploader avatar-uploaders"
          :show-file-list="false"
          :action="`${urlss}/file/oss-upload`"
          list-type="picture-card"
          :on-success="successHandlerLogo"
          :on-progress="progressClassImg"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="list.classesPhoto"
            :src="
              list.serverHttp == null
                ? list.classesPhoto
                : list.serverHttp + list.classesPhoto
            "
            class="avatar avatasr"
          />
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
     
    </div>
    <div v-else>您不是教师，暂时不能操作！</div>
    <canvas></canvas>
  </div>
</template>
<script>
import EXIF from 'exif-js'
import {
  classesphoto,
  urls,
  classesclassesphoto,
  usercenterinfo,
  historyList,
  currentTerm,
  fileUpload,
} from '@/api/home'
export default {
  data() {
    return {
      list: {},
      urlss: urls,
      imgs: '',
      show: true,
      termList: [],
      termId: '',
      loading: '',
    }
  },
  created() {
    this.historyList()
    this.currentTerm()
  },
  watch: {},
  methods: {
    // 学期变化
    changeTerm(e) {
      this.termId = e
      this.classesphoto()
    },
    // 获取学期列表
    historyList() {
      historyList().then((res) => {
        this.termList = res.data.data
      })
    },
    // 获取当前学期
    currentTerm() {
      currentTerm().then((res) => {
        this.termId = res.data.data.id
        this.usercenterinfo()
      })
    },
    // 获取班级照
    classesphoto() {
      let that = this
      let params = {
        classesId: localStorage.getItem('classId'),
        termId: that.termId,
      }
      classesphoto(params)
        .then((res) => {
          that.list = res.data.data
        })
        .catch(() => {})
    },
    successHandlerLogo(response, file, fileList) {
      this.getImgSize(response.data[0].url).then((res) => {
        if (res.width < res.height) {
          this.loading.close()
          this.$message({
            message: '图片解析成功，请点击保存按钮',
            type: 'success',
          })
          if (this.list.serverHttp == null) {
            this.list.classesPhoto = response.data[0].url
          } else {
            this.list.classesPhoto = response.data[0].fileName
          }
          return false
        }
        // this.$message.error('图片解析失败，请上传竖版照片')
        this.imghen(response.data[0].url)
      })
    },
    // 班级照提交
    bao() {
      let that = this
      let result = ''
      if (this.list.classesPhoto !== null && this.list.classesPhoto !== '') {
        if (this.list.classesPhoto.indexOf('http') != -1) {
          var str = this.list.classesPhoto //要截取的字符串
          var index = str.indexOf('com/')
          result = str.substr(index + 4, str.length)
        } else {
          result = this.list.classesPhoto
        }
      } else {
        this.$message({
          message: '请上传班级集体照！',
          type: 'success',
        })
        return false
      }
      let params = {
        classesId: localStorage.getItem('classId'),
        classesPhoto: result,
        termId: this.list.termId,
        termName: this.list.termName,
        id: this.list.id,
      }
      classesclassesphoto(params)
        .then((res) => {
          // that.list=res.data.data
          that.$message({
            message: '保存成功！',
            type: 'success',
          })
        })
        .catch(() => {})
    },
    usercenterinfo() {
      let that = this
      let params = {}
      usercenterinfo(params)
        .then((res) => {
          if (res.data.data.teacher.classesVo.id) {
            that.classesphoto()
          } else {
            that.show = false
          }
        })
        .catch(() => {})
    },

    beforeAvatarUpload(file) {},
    // 横版转竖版
    imghen(url) {
      let that = this
      return new Promise((resolve) => {
        let img = new Image()
        img.setAttribute('crossOrigin', '*')
        img.src = url
        img.onload = function () {
          const data = that.rotateImage(img, img.width, img.height)
          const newFile = that.dataURLtoFile(data, 'imgs')
          let prarms = new FormData()
          prarms.append('file', newFile)
          // 生成新的图片后上传
          fileUpload(prarms).then((res) => {
            that.list.classesPhoto = res.data.data[0].fileName
            that.loading.close()
            that.$message({
              message: '图片解析成功，请点击保存按钮',
              type: 'success',
            })
          })
          resolve(newFile)
        }
      })
    },
    progressClassImg(resp, file, fileList) {
      this.loading = this.$loading({
        lock: true,
        text: '图片解析中，请稍后。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      // if (resp.loaded === resp.total) {

      // }
    },

    async getData(url) {
      // 获取数据后传入图片url获取尺寸(宽高)
      const img = await this.getImgSize(url)
      return img
    },
    // 获取图片尺寸
    getImgSize(url) {
      return new Promise((resolve, reject) => {
        let imgObj = new Image()
        imgObj.src = url
        imgObj.onload = () => {
          resolve({
            width: imgObj.width,
            height: imgObj.height,
          })
        }
      })
    },

    getOrientation: (file) => {
      return new Promise((resolve) => {
        EXIF.getData(file, function () {
          const orient = EXIF.getTag(this, 'Orientation')
          console.log(orient)
          resolve(orient)
        })
      })
    },

    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },

    rotateImage(image, width, height) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      ctx.save()
      canvas.width = height
      canvas.height = width
      ctx.rotate((90 * Math.PI) / 180)
      ctx.drawImage(image, 0, -height)
      ctx.restore()
      return canvas.toDataURL('image/jpeg')
    },
  },
  mounted() {},
}
</script>


// WEBPACK FOOTER //
// src/views/school/components/picture.vue